// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"203f8221","57":"6bfc38f2","144":"879cd674","255":"19c18c05","806":"537428fb","990":"3038497a"}[chunkId] + ".chunk.js";
};